import React, { FunctionComponent } from "react";
import { Link } from "gatsby";
import { TOPICS, TopicKey } from "../../topics";

export interface SectionHeader {
  topic: TopicKey;
  title: string;
  link?: { href: string; label: string };
}

export const SectionHeader: FunctionComponent<SectionHeader> = ({
  topic,
  title,
  link,
}) => (
  <div
    className={`flex items-baseline justify-between gap-4 border-t-[6px] pt-3.5 ${TOPICS[topic].borderClass}`}
  >
    <h2 className="font-display text-h2-sm font-extrabold md:text-h2">
      {title}
    </h2>
    {link && (
      <Link
        to={link.href}
        className={`flex-shrink-0 font-display text-ui font-semibold hover:underline ${TOPICS[topic].textClass}`}
      >
        {link.label} →
      </Link>
    )}
  </div>
);
